/*-----------------------------------------------------------------
- Careers
-----------------------------------------------------------------*/
export default {
    titles: {
        list  : 'Careers',
        single: 'Careers - {0}',
    },

    send_cv        : 'Send us your',
    cv             : 'CV',
    apply_for_job  : 'Apply For This Job',
    success_save_cv: 'Your CV was sent successfully',
};
